import React from "react";
import {
    AppBar,
    Box,
    CircularProgress,
    IconButton,
    List,
    ListItem,
    ListItemText,
    Toolbar,
    Typography,
    Divider,
    Avatar,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {useQuery} from "@apollo/client";
import {useNavigate} from "react-router-dom";
import {GET_TRANSACTIONS} from "../graphql/query";

const JournalScreen = () => {
    const navigate = useNavigate();
    const {loading, error, data} = useQuery(GET_TRANSACTIONS);

    const handleBack = () => {
        navigate(-1); // Возврат на предыдущую страницу
    };

    if (loading) {
        return (
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100vh",
                    bgcolor: "background.default",
                    color: "text.primary",
                }}
            >
                <CircularProgress />
            </Box>
        );
    }

    if (error) {
        return (
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100vh",
                    bgcolor: "background.default",
                    color: "text.primary",
                }}
            >
                <Typography color="error">Ошибка загрузки транзакций: {error.message}</Typography>
            </Box>
        );
    }

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                height: "100vh",
                bgcolor: "background.default",
                color: "text.primary",
            }}
        >
            <AppBar position="static" color="default">
                <Toolbar>
                    <IconButton edge="start" color="inherit" onClick={handleBack} aria-label="Назад">
                        <ArrowBackIcon />
                    </IconButton>
                    <Typography variant="h6" sx={{ flexGrow: 1 }}>
                        Журнал транзакций
                    </Typography>
                </Toolbar>
            </AppBar>

            <Box sx={{ flex: 1, px: 2, pt: 2 }}>
                <List>
                    {data.transactions.map((transaction) => (
                        <React.Fragment key={transaction.id}>
                            <ListItem alignItems="flex-start">
                                <ListItemText
                                    primary={`Сумма: ${transaction.sum / 100} ₽`}
                                    secondary={
                                        <>
                                            <Typography variant="body2">
                                                Дата: {new Date(transaction.datetime).toLocaleDateString()}
                                            </Typography>
                                            <Typography variant="body2">
                                                Комментарий: {transaction.comment || "Нет"}
                                            </Typography>
                                            <Typography variant="body2">
                                                Проект: {transaction.project.name}
                                            </Typography>
                                        </>
                                    }
                                />
                                {transaction.receipt?.id && (
                                    <Box
                                        component="img"
                                        src={process.env.REACT_APP_RECEIPT_IMG_URL + transaction.receipt.id}
                                        alt="Чек"
                                        sx={{
                                            width: 56,
                                            height: 56,
                                            marginLeft: 2,
                                        }}
                                    />
                                )}
                            </ListItem>
                            <Divider />
                        </React.Fragment>
                    ))}
                </List>
            </Box>
        </Box>
    );
};

export default JournalScreen;
